import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Id, toast } from "react-toastify";
import { Err } from "samuel-types";

// The InitialState For The Slice
const initialState: {
  allowanceOverviews: Drivn.AllowanceOverview[] | [];
  loading: boolean;
  error?: Err;
  activeMonth: number;
  alreadyDispatched: boolean;
} = {
  allowanceOverviews: [],
  loading: false,
  error: undefined,
  activeMonth: new Date().getMonth(),
  alreadyDispatched: false
};

// The Authentication Redux Slice
const allowanceSlice = createSlice({
  name: "allowance",
  initialState: initialState,
  reducers: {
    startAllowanceUpdate(state) {
      state.loading = true;
      return state;
    },
    allowanceError: (
      state,
      newValue: PayloadAction<[import("samuel-types").Err, Id | undefined]>
    ) => {
      if (newValue.payload[1]) {
        toast.update(newValue.payload[1], {
          render: newValue.payload[0].message,
          type: "error",
          isLoading: false,
          autoClose: 5000
        });
      } else {
        // Toast
        toast.error(newValue.payload[0].message);
      }

      // Setting The State
      return {
        ...state,
        loading: false,
        error: newValue.payload[0],
        alreadyDispatched: true
      };
    },
    setAllowanceOverview(
      state,
      newValue: PayloadAction<Drivn.AllowanceOverview[] | []>
    ) {
      state.allowanceOverviews = newValue.payload;
      state.loading = false;
      state.error = undefined;
      state.alreadyDispatched = false;
      return state;
    },
    setActiveMonth: (
      state,
      newValue: PayloadAction<number>
    ) => {
      state.activeMonth = newValue.payload;
      return state;
    }
  }
});
// Exporting The Actions
export const {
  setAllowanceOverview,
  allowanceError,
  startAllowanceUpdate,
  setActiveMonth
} = allowanceSlice.actions;

// Exporting The Slice
export default allowanceSlice;
